export default "__VITE_ASSET__Bm1AO$Yx__"